<template>
    <div>
      <h3 class="header-title">Learning Center</h3>
      <label>Let’s see your tuition center.</label>
      <br />
      <div class="custom-explore">
        <div>
          <CRow>
            <CCol sm="12">
              <div style="width: 80%" class="float-left">
                <img
                  src="../assets/img/iconnoti.svg"
                  class="ml-5 mr-2 mb-3 mt-3"
                />
                <span class="text-white mt-3 mb-2"> | </span>
                <label class="ml-2 text-white mt-3 mb-2"
                  >Explore more on your tuition center !</label
                >
              </div>
              <div style="width: 20%" class="float-right p-0">
                <br /><br />
                <img
                  src="../assets/img/icontriangle.svg"
                  class="ml-5 mr-2"
                  style="
                    position: absolute;
                    top: 0;
                    right: 100px;
                    bottom: 0;
                    height: 55px;
                  "
                />
              </div>
            </CCol>
          </CRow>
        </div>
      </div>
      <div v-if="Busy == true">
        <CCol sm="12" md="12">
          <div class="app flex-row align-items-center">
            <div class="container d-flex justify-content-center">
              <PulseLoader float />
            </div>
          </div>
        </CCol>
      </div>
      <div v-else>
        <CCol sm="12" class="mt-4">
          <CRow>
            <CCol sm="4">
              <CInput
                type="text"
                placeholder="Search text"
                v-model.lazy="SearchQuery"
                @change="ApplyFilter()"
              />
            </CCol>
          </CRow>
  
          <CRow>
            <CCol sm="3">
              <!-- <v-select
                v-model="selectedName"
                :options="nameOptions"
                label="Name"
                class="custom-btn-blue style-chooser"
                @input="FilteredData()"
              ></v-select> -->
            </CCol>
  
            <CCol sm="3">
              <!-- <v-select
                v-model="selectedView"
                :options="viewOptions"
                label="IsSeen"
                class="custom-btn-blue style-chooser"
                @input="FilteredData()"
              ></v-select> -->
            </CCol>
  
            <CCol sm="3"> </CCol>
  
            <CCol sm="3">
              <!-- <CButton
                class="custom-btn-success"
                type="button"
                @click="OpenFormBroadcast()"
                ><CIcon name="cil-plus" />Add Broadcast</CButton
              > -->
            </CCol>
          </CRow>
        </CCol>
        <CCol sm="12">
          <CDataTable
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="FilteredTc"
            :fields="fields"
            items-per-page-select
            :items-per-page="small ? 5 : 10"
            clickable-rows
            sorter
            pagination
          >
            <template #Code="{ item }">
              <td>
                <h6 style="color: #1e109c" class="text-uppercase">
                  {{ item.Id }}
                </h6>
              </td>
            </template>
  
            <template #TuitionCenter="{ item }">
              <td>
               <strong> {{ item.Name }} </strong>
                <br />
               {{ item.Email }}  <br />
               {{ item.PhoneNumber }}
              </td>
            </template>
  
            <template #CountryName="{ item }">
              <td>
                {{ item.CountryName }}
                <br />
                Currency: {{ item.Currency }} ({{ item.SymbolCurrency }})

              </td>
            </template>
  
         
          </CDataTable>
        </CCol>
  
      </div>
    </div>
  </template>
  
  
  
  <script>
  import Vue from "vue";
  Vue.use(require("vue-moment"));
  import FullCalendar from "vue-full-calendar";
  import "fullcalendar/dist/fullcalendar.css";
  import VCalendar from "v-calendar";
  import VueCal from "vue-cal";
  import "vue-cal/dist/vuecal.css";
  
  import _ from "lodash";
  import PulseLoader from "vue-spinner/src/PulseLoader.vue";
  import { CChartBar } from "@coreui/vue-chartjs";
  import VueEllipseProgress from "vue-ellipse-progress";
  
  import "@fullcalendar/core/vdom"; // solves problem with Vite]
  
  import { Calendar } from "vue-sweet-calendar";
  import "vue-sweet-calendar/dist/SweetCalendar.css";
  import "material-design-icons-iconfont/dist/material-design-icons.css";
  
  Vue.use(FullCalendar);
  Vue.use(VueEllipseProgress);
  
  export default {
    name: "Collapses",
    components: {
      PulseLoader,
      CChartBar,
      Calendar,
      VCalendar,
      VueCal,
    },
    data() {
      return {
        tc: [],
        FilteredTc: [],
        SearchQuery: "",
  
        perPage: 10,
        pagination: {},
        currentPage: 1,
  
        Busy: false,
  
        fields: [
          { key: "Code" },
          { key: "TuitionCenter" },
          { key: "CountryName" },
        ],
        small: "",
        fixed: "",
        bordered: "",
      };
    },
    async mounted() {
      let isAuth = await this.UserAuth();
  
      if (isAuth) {
        this.Busy = false;
        this.GetListTc();
      } else {
        this.GoToLogin();
      }
    },
  
    async mounted() {
      this.GetListTc();
    },
    methods: {
      GetListTc() {
        this.Busy = true;
        this.$API
          .get(this.$ListTc, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200 && response.data != null) {
              this.Busy = false;
              this.tc = response.data;
              this.FilteredTc = this.tc;
  
            //   var parentNames = _.uniq(_.map(response.data, "Name"));
            //   parentNames.sort(function (a, b) {
            //     return a.toLowerCase().localeCompare(b.toLowerCase());
            //   });
            //   this.nameOptions = parentNames;
            //   this.nameOptions.unshift("ALL PARENT");
  
            //   var viewNames = _.uniq(_.map(response.data, "IsSeen"));
            //   this.viewOptions = viewNames;
            //   this.viewOptions.unshift("ALL VIEW");
            }
          });
      },
      ApplyFilter: function () {
        var arr = _.orderBy(this.tc, ["Name"], ["asc"]);
        if (_.isEmpty(arr) == false) {
          const result = _.filter(arr, ({ Name, Email, CountryName, PhoneNumber }) =>
            _.some([
              _.includes(!Name || Name.toLowerCase(), [
                this.SearchQuery.toLowerCase(),
              ]),
              _.includes(!Email || Email.toLowerCase(), [
                this.SearchQuery.toLowerCase(),
              ]),
              _.includes(!PhoneNumber || PhoneNumber.toLowerCase(), [
                this.SearchQuery.toLowerCase(),
              ]),
              _.includes(!CountryName || CountryName.toLowerCase(), [
                this.SearchQuery.toLowerCase(),
              ]),
            ])
          );
          this.Filteredtc = result;
        }
      },
    

    },
  };
  </script>
  
  
  <style>
  @import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
  .custom-btn-success {
    color: #fff;
    background-color: #2eb85c;
    border-color: #2eb85c;
    width: 230px;
  }
  .style-chooser .vs__open-indicator {
    fill: rgb(251 248 254);
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transition: -webkit-transform 150ms
      cubic-bezier(1, -0.115, 0.975, 0.855);
    transition: -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
    transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
    transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855),
      -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
    -webkit-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
    transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  }
  .style-chooser .vs__clear {
    fill: rgb(251 248 254);
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    margin-right: 8px;
  }
  .style-chooser .vs__dropdown-toggle {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 0 0 4px 0;
    background: none;
    border: 1px solid #009efb;
    border-radius: 4px;
    white-space: normal;
    height: 36px;
  }
  .style-chooser .vs__selected {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #009efb;
    border: 1px solid #009efb;
    border-radius: 4px;
    color: #fff;
    line-height: 1.4;
    margin: 4px 2px 0px 2px;
    padding: 0 0.25em;
    z-index: 0;
  }
  .style-chooser .vs__single .vs__selected {
    background-color: #009efb;
    border-color: #009efb;
  }
  .custom-btn-blue {
    background: #009efb;
    border: 1px solid #009efb;
    color: #ffffff;
    border-radius: 4px;
  }
  </style>
  
  
  
  